/* eslint-disable no-console */
// import { databaseGoalsToLocalGoals } from '../../catalog/Game';
import { sendErrorAnalytics } from '../../../catalog/Analytics';
import { databaseGoalsToLocalGoals, databaseHighlightsPerPlayerToLocalHighlightsPerPlayer, databasePenaltiesToLocalPenalties, databaseFaceOffsToLocalFaceOffs } from '../../../catalog/stats/iceHockey/IceHockeyDatabaseStatsToLocalStats';
import { FETCH_GAMES_ERROR, FETCH_GAME_ERROR, GAME_DOES_NOT_EXIST, OPPONENT_DOES_NOT_EXIST } from '../../../catalog/NotificationsComments';
import { databaseTagsToLocalTags } from '../../../catalog/Tags';
import { optimXTesting } from '../../../catalog/TeamInfo';
import { isValidObject } from '../../../catalog/Validity';
import { fetchGameFirestoreAPI, fetchGamesFirestoreAPI, fetchLimitedPreviousGamesFirestoreAPI, fetchLimitedPreviousGamesOfSeasonFirestoreAPI, fetchLimitedScheduledGamesFirestoreAPI, fetchLimitedScheduledGamesOfSeasonFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsGame';
import { fetchLeagueFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsLeague';
import { fetchOpponentFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsOpponent';
import { fetchPreDevelopedLeagueFirestoreAPI, fetchPreDevelopedConferenceFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsPreDevelopedLeague';
import { databaseCarriesToLocalCarries, databaseConversionsToLocalConversions, databaseDropGoalsToLocalDropGoals, databaseFoulsToLocalFouls, databaseMetersCarriedToLocalMetersCarried, databaseMinsPlayedToLocalMinsPlayed, databaseOffloadsToLocalOffloads, databasePassesToLocalPasses, databasePenaltyKicksToLocalPenaltyKicks, databaseTacklesToLocalTackles, databaseTriesToLocalTries } from '../../../catalog/stats/rugby/RugbyDatabaseStatsToLocalStats';
import { databaseGroundBallsToLocalGroundBalls, databaseTurnOversToLocalTurnOvers } from '../../../catalog/stats/lacrosse/LacrosseDatabaseStatsToLocalStats';

export const fetchGamesAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const games: any = [];
    try {
        const docs = await fetchGamesFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                games.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchGames', games });
    } catch (error) {
        sendErrorAnalytics(FETCH_GAMES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GAMES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedPreviousGamesOfSeasonAPI = async (teamId: string, seasonId: string, count: number, setState: Function, snackbar: Function) => {
    const tempGames: any = [];
    let games: any = [];
    try {
        const docs = await fetchLimitedPreviousGamesOfSeasonFirestoreAPI(teamId, seasonId, count);

        docs.forEach((doc) => {
            if (doc.exists) {
                tempGames.push({ ...doc.data() });
            }
        });
        games = new Array<any>(tempGames.length);
        await Promise.all(tempGames.map(async (game: any, index: number) => {
            const opponentDoc = await fetchOpponentFirestoreAPI(teamId, game.opponentId);
            const opponent = opponentDoc.data();
            const leagueDoc = await fetchLeagueFirestoreAPI(teamId, game.leagueId);
            const league = leagueDoc.data();
            const preDevelopedLeagueDoc = await fetchPreDevelopedLeagueFirestoreAPI(league?.preDevelopedLeagueId);
            const preDevelopedLeague = preDevelopedLeagueDoc.data();
            const preDevelopedConferenceDoc = await fetchPreDevelopedConferenceFirestoreAPI(league?.preDevelopedLeagueId, league?.preDevelopedConferenceId);
            const preDevelopedConference = preDevelopedConferenceDoc.data();
            games[index] = { ...game, opponentLogo: opponent?.logo, opponentName: opponent?.name, leagueName: `${preDevelopedLeague?.name} - ${preDevelopedConference?.name}` };
        }));
        setState({ type: 'fetchPreviousGames', games });
    } catch (error) {
        sendErrorAnalytics(FETCH_GAMES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GAMES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedScheduledGamesOfSeasonAPI = async (teamId: string, seasonId: string, count: number, setState: Function, snackbar: Function) => {
    const tempGames: any = [];
    let games: any = [];
    try {
        const docs = await fetchLimitedScheduledGamesOfSeasonFirestoreAPI(teamId, seasonId, count);

        docs.forEach((doc) => {
            if (doc.exists) {
                tempGames.push({ ...doc.data() });
            }
        });
        games = new Array<any>(tempGames.length);
        await Promise.all(tempGames.map(async (game: any, index: number) => {
            const opponentDoc = await fetchOpponentFirestoreAPI(teamId, game.opponentId);
            const opponent = opponentDoc.data();
            const leagueDoc = await fetchLeagueFirestoreAPI(teamId, game.leagueId);
            const league = leagueDoc.data();
            const preDevelopedLeagueDoc = await fetchPreDevelopedLeagueFirestoreAPI(league?.preDevelopedLeagueId);
            const preDevelopedLeague = preDevelopedLeagueDoc.data();
            const preDevelopedConferenceDoc = await fetchPreDevelopedConferenceFirestoreAPI(league?.preDevelopedLeagueId, league?.preDevelopedConferenceId);
            const preDevelopedConference = preDevelopedConferenceDoc.data();
            games[index] = { ...game, opponentLogo: opponent?.logo, opponentName: opponent?.name, leagueName: `${preDevelopedLeague?.name} - ${preDevelopedConference?.name}` };
        }));
        setState({ type: 'fetchScheduledGames', games });
    } catch (error) {
        sendErrorAnalytics(FETCH_GAMES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GAMES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedPreviousGamesAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const tempGames: any = [];
    let games: any = [];
    try {
        const docs = await fetchLimitedPreviousGamesFirestoreAPI(teamId, count);

        docs.forEach((doc) => {
            if (doc.exists) {
                tempGames.push({ ...doc.data() });
            }
        });
        games = new Array<any>(tempGames.length);
        await Promise.all(tempGames.map(async (game: any, index: number) => {
            const opponentDoc = await fetchOpponentFirestoreAPI(teamId, game.opponentId);
            const opponent = opponentDoc.data();
            const leagueDoc = await fetchLeagueFirestoreAPI(teamId, game.leagueId);
            const league = leagueDoc.data();
            const preDevelopedLeagueDoc = await fetchPreDevelopedLeagueFirestoreAPI(league?.preDevelopedLeagueId);
            const preDevelopedLeague = preDevelopedLeagueDoc.data();
            const preDevelopedConferenceDoc = await fetchPreDevelopedConferenceFirestoreAPI(league?.preDevelopedLeagueId, league?.preDevelopedConferenceId);
            const preDevelopedConference = preDevelopedConferenceDoc.data();
            games[index] = { ...game, opponentLogo: opponent?.logo, opponentName: opponent?.name, leagueName: `${preDevelopedLeague?.name} - ${preDevelopedConference?.name}` };
        }));
        setState({ type: 'fetchPreviousGames', games });
    } catch (error) {
        sendErrorAnalytics(FETCH_GAMES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GAMES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedScheduledGamesAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const tempGames: any = [];
    let games: any = [];
    try {
        const docs = await fetchLimitedScheduledGamesFirestoreAPI(teamId, count);

        docs.forEach((doc) => {
            if (doc.exists) {
                tempGames.push({ ...doc.data() });
            }
        });
        games = new Array<any>(tempGames.length);
        await Promise.all(tempGames.map(async (game: any, index: number) => {
            const opponentDoc = await fetchOpponentFirestoreAPI(teamId, game.opponentId);
            const opponent = opponentDoc.data();
            const leagueDoc = await fetchLeagueFirestoreAPI(teamId, game.leagueId);
            const league = leagueDoc.data();
            const preDevelopedLeagueDoc = await fetchPreDevelopedLeagueFirestoreAPI(league?.preDevelopedLeagueId);
            const preDevelopedLeague = preDevelopedLeagueDoc.data();
            const preDevelopedConferenceDoc = await fetchPreDevelopedConferenceFirestoreAPI(league?.preDevelopedLeagueId, league?.preDevelopedConferenceId);
            const preDevelopedConference = preDevelopedConferenceDoc.data();
            games[index] = { ...game, opponentLogo: opponent?.logo, opponentName: opponent?.name, leagueName: `${preDevelopedLeague?.name} - ${preDevelopedConference?.name}` };
        }));
        setState({ type: 'fetchScheduledGames', games });
    } catch (error) {
        sendErrorAnalytics(FETCH_GAMES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GAMES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchGameTitleAPI = async (gameId: string, setState: Function, snackbar: Function) => {
    try {
        const gameDoc = await fetchGameFirestoreAPI(gameId);
        if (gameDoc.exists && gameDoc.data() !== null && gameDoc.data() !== undefined) {
            const game = gameDoc.data();
            setState({ type: 'fetchGameTitle', title: game?.title });
        } else {
            sendErrorAnalytics(GAME_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GAME_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_GAME_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_GAME_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchIceHockeyGameAPI = async (teamId: string, gameId: string, setState: Function, snackbar: Function) => {
    try {
        const gameDoc = await fetchGameFirestoreAPI(gameId);
        if (gameDoc.exists && gameDoc.data() !== null && gameDoc.data() !== undefined) {
            const game = gameDoc.data();
            const tags = await databaseTagsToLocalTags(game?.tagIds, game?.tagReferences, game?.tagTypes, teamId);
            const goals = await databaseGoalsToLocalGoals(game?.goals);
            const highlightsPerPlayer = await databaseHighlightsPerPlayerToLocalHighlightsPerPlayer(game?.highlightsPerPlayer);
            const penalties = await databasePenaltiesToLocalPenalties(game?.penalties);
            const faceOffs = await databaseFaceOffsToLocalFaceOffs(game?.faceOffs);
            const opponentDoc = await fetchOpponentFirestoreAPI(game?.teamId, game?.opponentId);

            if (opponentDoc.exists && isValidObject(opponentDoc.data())) {
                const opponent = opponentDoc.data();
                setState({ type: 'fetchGame',
                    leagueId: game?.leagueId,
                    opponentId: game?.opponentId,
                    opponentName: opponent?.name,
                    opponentLogo: opponent?.logo,
                    articleId: game?.articleId,
                    galleryId: game?.galleryId,
                    preDevelopedSeasonId: game?.preDevelopedSeasonId,
                    title: game?.title,
                    homeGame: game?.homeGame,
                    status: game?.status,
                    timeOfGame: game?.timeOfGame,
                    venue: game?.venue,
                    attendance: game?.attendance,
                    promotionalText: game?.promotionalText,
                    promotionalVideo: isValidObject(game?.promotionalVideo) ? game?.promotionalVideo : { title: '', description: '', type: '', url: '' },
                    tags,
                    featureImage: game?.featureImage,
                    notes: game?.notes,
                    game: { ...game, tags, goals, highlightsPerPlayer, penalties, faceOffs },
                });
            } else {
                sendErrorAnalytics(OPPONENT_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(OPPONENT_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(GAME_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GAME_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_GAME_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_GAME_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchRugbyGameAPI = async (teamId: string, gameId: string, setState: Function, snackbar: Function) => {
    try {
        const gameDoc = await fetchGameFirestoreAPI(gameId);
        if (gameDoc.exists && gameDoc.data() !== null && gameDoc.data() !== undefined) {
            const game = gameDoc.data();
            const tags = await databaseTagsToLocalTags(game?.tagIds, game?.tagReferences, game?.tagTypes, teamId);
            const tries = await databaseTriesToLocalTries(game?.tries);
            const conversions = await databaseConversionsToLocalConversions(game?.conversions);
            const penaltyKicks = await databasePenaltyKicksToLocalPenaltyKicks(game?.penaltyKicks);
            const dropGoals = await databaseDropGoalsToLocalDropGoals(game?.dropGoals);
            const fouls = await databaseFoulsToLocalFouls(game?.fouls);
            const tackles = await databaseTacklesToLocalTackles(game?.tackles);
            const offloads = await databaseOffloadsToLocalOffloads(game?.offloads);
            const carries = await databaseCarriesToLocalCarries(game?.carries);
            const passes = await databasePassesToLocalPasses(game?.passes);
            const metersCarried = await databaseMetersCarriedToLocalMetersCarried(game?.metersCarried);
            const minsPlayed = await databaseMinsPlayedToLocalMinsPlayed(game?.minsPlayed);
            const opponentDoc = await fetchOpponentFirestoreAPI(game?.teamId, game?.opponentId);

            if (opponentDoc.exists && isValidObject(opponentDoc.data())) {
                const opponent = opponentDoc.data();
                setState({ type: 'fetchGame',
                    leagueId: game?.leagueId,
                    opponentId: game?.opponentId,
                    opponentName: opponent?.name,
                    opponentLogo: opponent?.logo,
                    articleId: game?.articleId,
                    galleryId: game?.galleryId,
                    preDevelopedSeasonId: game?.preDevelopedSeasonId,
                    title: game?.title,
                    homeGame: game?.homeGame,
                    status: game?.status,
                    timeOfGame: game?.timeOfGame,
                    venue: game?.venue,
                    attendance: game?.attendance,
                    promotionalText: game?.promotionalText,
                    promotionalVideo: isValidObject(game?.promotionalVideo) ? game?.promotionalVideo : { title: '', description: '', type: '', url: '' },
                    tags,
                    featureImage: game?.featureImage,
                    notes: game?.notes,
                    game: { ...game, tags, tries, conversions, penaltyKicks, dropGoals, fouls, tackles, offloads, carries, passes, metersCarried, minsPlayed },
                });
            } else {
                sendErrorAnalytics(OPPONENT_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(OPPONENT_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(GAME_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GAME_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_GAME_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_GAME_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLacrosseGameAPI = async (teamId: string, gameId: string, setState: Function, snackbar: Function) => {
    try {
        const gameDoc = await fetchGameFirestoreAPI(gameId);
        if (gameDoc.exists && gameDoc.data() !== null && gameDoc.data() !== undefined) {
            const game = gameDoc.data();
            const tags = await databaseTagsToLocalTags(game?.tagIds, game?.tagReferences, game?.tagTypes, teamId);
            const goals = await databaseGoalsToLocalGoals(game?.goals);
            const highlightsPerPlayer = await databaseHighlightsPerPlayerToLocalHighlightsPerPlayer(game?.highlightsPerPlayer);
            const penalties = await databasePenaltiesToLocalPenalties(game?.penalties);
            const faceOffs = await databaseFaceOffsToLocalFaceOffs(game?.faceOffs);
            const turnOvers = await databaseTurnOversToLocalTurnOvers(game?.turnOvers);
            const groundBalls = await databaseGroundBallsToLocalGroundBalls(game?.groundBalls);
            const opponentDoc = await fetchOpponentFirestoreAPI(game?.teamId, game?.opponentId);

            if (opponentDoc.exists && isValidObject(opponentDoc.data())) {
                const opponent = opponentDoc.data();
                setState({ type: 'fetchGame',
                    leagueId: game?.leagueId,
                    opponentId: game?.opponentId,
                    opponentName: opponent?.name,
                    opponentLogo: opponent?.logo,
                    articleId: game?.articleId,
                    galleryId: game?.galleryId,
                    preDevelopedSeasonId: game?.preDevelopedSeasonId,
                    title: game?.title,
                    homeGame: game?.homeGame,
                    status: game?.status,
                    timeOfGame: game?.timeOfGame,
                    venue: game?.venue,
                    attendance: game?.attendance,
                    promotionalText: game?.promotionalText,
                    promotionalVideo: isValidObject(game?.promotionalVideo) ? game?.promotionalVideo : { title: '', description: '', type: '', url: '' },
                    tags,
                    featureImage: game?.featureImage,
                    notes: game?.notes,
                    game: { ...game, tags, goals, highlightsPerPlayer, penalties, faceOffs, turnOvers, groundBalls },
                });
            } else {
                sendErrorAnalytics(OPPONENT_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(OPPONENT_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(GAME_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GAME_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_GAME_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_GAME_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};
